import React from 'react';

import { Box, Button, Stack, Typography } from '@mui/material';

import ImageFluid from '../../legacy/components/base/ImageFluid';
import RawHtml from '../../legacy/components/base/RawHtml';

/* === HERO V2 PROPS ================================================================== */
interface HeroV2Props {
  title: string;
  description?: string;
  subtitle?: string;
  textCall?: string;
  urlCall?: string;

  height?: 'viewport' | 'fit-content';

  bottomText: string;
  // FIXME: This is a placeholder for now. This will be updated
  fluid: any;

  /**
   * Raw HTML.
   */
  multimediaContent?: string;

  linearGradient: string;
}

export const HeroV2 = (props: HeroV2Props) => {
  /* === CONDITIONAL RENDER (MULTIMEDIA VARIANT) ====================================== */
  if (props.multimediaContent) {
    return <HeroV2MultimediaVariant {...props} />;
  }

  /* === MAIN RENDER ================================================================== */
  return (
    <Box
      component="section"
      position="relative"
      height={props.height === 'viewport' ? { xs: 'fit-content', lg: 'calc(100vh - 72px)' /** Navbar height on Desktop 72px */ } : 'fit-content'}
      overflow="hidden"
    >
      <Box position="absolute" top={0} zIndex={10} height="100%" width="100%">
        <ImageFluid fluid={props.fluid} />
      </Box>

      <Box position="absolute" top={0} zIndex={20} width={'100%'} height={'100%'} sx={{ background: props.linearGradient }}></Box>

      <Box
        position="relative"
        zIndex={30}
        display="flex"
        alignItems="center"
        width="100%"
        height="100%"
        py={props.height === 'viewport' ? { xs: 12, lg: 0 } : 6}
        px={{ xs: '40px', md: '148px' }}
      >
        <Stack maxWidth={800}>
          <Typography variant="h1" color="white" fontFamily="Gotham-Bold" fontSize={40}>
            <RawHtml content={props.title} />
          </Typography>
          {props.subtitle ? (
            <Typography variant="h2" color="white" fontFamily="Gotham-Light" fontSize={40} mt={0 /** Remove default margin top. Default is added by Material UI */}>
              <RawHtml content={props.subtitle} />
            </Typography>
          ) : null}

          {props.description ? (
            <Typography variant="subtitle1" color="white" fontSize={{ xs: 14, lg: 20 }} fontFamily="Gotham-Medium" mt={5.25}>
              {props.description}
            </Typography>
          ) : null}
          <Stack width="min-content" mt={4}>
            {props.urlCall && (
              <Button href={props.urlCall} variant="contained" size="large" sx={{ width: 'max-content', px: 5.25, '&.MuiButton-contained.MuiButton-sizeLarge': { px: 5.25 } }}>
                {props.textCall}
              </Button>
            )}
            {props.bottomText ? (
              <Typography align="center" color="white" fontSize="16px" fontFamily="Gotham-Book" mt={2.5}>
                {props.bottomText}
              </Typography>
            ) : null}
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

const HeroV2MultimediaVariant = (props: HeroV2Props) => {
  /* === RENDER ======================================================================= */
  return (
    <Stack
      component="section"
      direction={{ xs: 'column', lg: 'row' }}
      position="relative"
      alignItems={{ xs: 'normal', lg: 'center' }}
      gap={{ xs: 5, lg: 12 }}
      height={{ xs: 'fit-content', lg: 'calc(100vh - 72px)' /** Navbar height on Desktop 72px */ }}
      py={{ xs: 5, lg: 0 }}
      px={{ xs: '40px', md: '148px' }}
      overflow="hidden"
    >
      <Box flex={1}>
        <Typography variant="h1" color="#272031" fontFamily="Gotham-Bold" fontSize={42}>
          <RawHtml content={props.title} />
        </Typography>
        {props.subtitle ? (
          <Typography variant="h2" color="#272031" fontFamily="Gotham-Medium" fontSize={20} mt={4}>
            <RawHtml content={props.subtitle} />
          </Typography>
        ) : null}

        {props.urlCall && (
          <Button
            href={props.urlCall}
            variant="contained"
            size="large"
            sx={{ display: { xs: 'none', md: 'flex' }, width: 'max-content', mt: 4, px: 5.25, '&.MuiButton-contained.MuiButton-sizeLarge': { px: 5.25 } }}
          >
            {props.textCall}
          </Button>
        )}
      </Box>

      <Box flex={1}>
        <RawHtml content={props.multimediaContent} />

        {props.urlCall && (
          <Button
            href={props.urlCall}
            variant="contained"
            size="large"
            sx={{ display: { xs: 'flex', md: 'none' }, width: '100%', mt: 4, px: 5.25, '&.MuiButton-contained.MuiButton-sizeLarge': { px: 5.25 } }}
          >
            {props.textCall}
          </Button>
        )}
      </Box>
    </Stack>
  );
};
